import {AfterViewInit, Component, HostListener, OnInit} from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { LegalPerson } from '@models/old/legalperson.model';
import { LocalstorageService } from '@services/localstorage.service';
import { MyContractService } from '@services/mycontract.service';
import {PostPaidContractBalance} from "@models/old/postpaidcontractbalance.model";
import {Router} from "@angular/router";
import {ProfileType} from "@variables/profileType";
import { AbstractProcessLauncher } from 'src/app/shared/abstracts/abstract-process-launcher';


@Component({
    selector: 'app-customer-header',
    templateUrl: './customer-header.component.html',
    styleUrls: ['./customer-header.component.scss'],
    standalone: false
})
export class CustomerHeaderComponent extends AbstractProcessLauncher implements OnInit, AfterViewInit {
  protected CLIENT_TYPE = {
    PRE: 1,
    POS: 2
  };
  public legalPerson: LegalPerson;
  companyName: any;
  haveManyContracts = null;
  BorderAnimation:boolean;
  hoverButton: boolean = false;
  hoverDropdown: boolean = false;
  isOpenAccount: boolean;
  postPaidContractBalance: PostPaidContractBalance;
  sizeScreen: number;
  isMenuOpen: boolean = false;
  isUserProfileBackOffice: boolean = false;
  isUserProfileRelationship: boolean = false;

  constructor(
    private oauthService: OAuthService,
    private myContractService: MyContractService,
    private localstorageService: LocalstorageService,
    private _route: Router
    ) {
    super(_route);
    this.isUserProfileBackOffice = this.userProfileService.isBackOffice();
    this.isUserProfileRelationship = this.userProfileService.isRelationship();
      this.companyName = {
        'name': '',
        'personDocumentTypeId': 0,
        'documentNumber': 0,
        'contractId' : 0,
        'nameContract': ''
      }
    }

  protected hasMultipleProfile(): boolean {
    return this.userProfileService.hasMultipleProfile();
  }

  ngOnInit() {
    this.getName();
  }

  ngAfterViewInit() {
    this.sizeScreen = window.innerWidth;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.sizeScreen = window.innerWidth;
  }

  openDropdown(element){
    if(element == 'button')
    this.hoverButton = true;

    if(element == 'dropdownItem')
    this.hoverDropdown = true;

    this.isOpenAccount = true;
    this.BorderAnimation = true;
  }

  closeDropdown(element){
        if(element == 'button')
        this.hoverButton = false;

        if(element == 'dropdownItem')
        this.hoverDropdown = false;

        if(!this.hoverButton && !this.hoverDropdown)
          this.isOpenAccount = false;
  }

  getLegalPerson() {
    this.myContractService.getLegalPerson()
    .subscribe(
      (success) => {
        this.legalPerson = success;
      },
      (error) => {
        console.log("Promise rejeitada: " + JSON.stringify(error));
        return;
      }
    );
  }

  getName() {
    this.companyName = this.userProfileService.isCustomerOrRelationshipProfile() ?  this.localstorageService.getUserInfo() : this.authService.getContractUserInfo();
  }

  logout() {
    this.authService.logOut();
  }

  get username(): string | null {
    let claims = this.oauthService.getIdentityClaims();
    return claims ? claims['given_name'] : null;
  }

  get email(): string | null {
    let claims = this.oauthService.getIdentityClaims();
    return claims ? claims['email'] : null;
  }

  getHaveManyContracts(): boolean {
    return this.localstorageService.getHaveManyContracts();
  }

  reciverPaidContractBalance(event: PostPaidContractBalance): void {
    if (event) {
      this.postPaidContractBalance = event;
    }
  }

  handleContractNameSize(companyName: any): string {
    const contractName: string = companyName.description;
    const trace: string = '- ';
    const reticences: string = '...';

    let maxLength: number = this.defineMaximumLengthForScreenSize();

    if (maxLength > 0 && contractName.length > maxLength) {
      return trace + contractName.slice(0, maxLength) + reticences;
    } else {
      return contractName.length > 0 ? trace + contractName : '';
    }
  }

  private defineMaximumLengthForScreenSize(): number {
    let maxLength: number;

    if (this.sizeScreen <= 320) {
      maxLength = 10;
    } else if (this.sizeScreen <= 360) {
      maxLength = 13;
    } else if (this.sizeScreen <= 428) {
      maxLength = 15;
    } else if (this.sizeScreen <= 1024) {
      maxLength = 30;
    } else {
      maxLength = 0;
    }

    return maxLength;
  }

  handleRouteByProfile() {
    let url: string = '/selecionar-contrato';

    if (this.isUserProfileBackOffice) {
     url = '/backoffice/atendimento/acessar-contrato';
    }

    this._route.navigateByUrl(url);
  }

  changeProfile() {
    this._route.navigateByUrl('/selecionar-perfil');
  }

  handleClassCustomized(): boolean {
    const exitsClass: any = document.querySelector('.Header_UserMenu_BT_Usuarios');
    return !exitsClass;
  }

}
